import { getEnabledEventsForRSVP, getEnabledAccommodationOptions } from '../config/eventsConfig';

export const RSVP_CONSTANTS = {
  // Section Metadata
  SECTION_ID: 'rsvp',
  TITLE_ID: 'rsvp-title',
  DESC_ID: 'rsvp-desc',

  // Section Titles & Descriptions
  SECTION_TITLE: 'RSVP',
  SECTION_DESCRIPTION: "We can't wait to celebrate with you! Please fill out the details below.",
  REQUIRED_INFO_TITLE: 'Required Information',
  OPTIONAL_INFO_TITLE: 'Additional Information (Optional)',

  // Confirmation Messages
  CONFIRMATION_TITLE: 'Thank You!',
  CONFIRMATION_MESSAGE_PREFIX: 'Your RSVP has been received. We can\'t wait to celebrate with you',
  CONFIRMATION_MESSAGE_SUFFIX: '!',
  CONFIRMATION_MESSAGE_WITH_EVENTS_PREFIX: ' at ',

  // Form Labels
  FULL_NAME_LABEL: 'Full Name(s) *',
  FULL_NAME_PLACEHOLDER: 'Your full name(s)',
  EVENTS_LABEL: 'Which events will you attend? *',
  PHONE_LABEL: 'Phone Number *',
  PHONE_PLACEHOLDER: 'Your contact number',
  EMAIL_LABEL: 'Email Address',
  EMAIL_PLACEHOLDER: 'Your email address',
  GUESTS_LABEL: 'How many additional guests (apart from you) will be attending?',
  GUESTS_PLACEHOLDER: 'Number of guests (including partners, kids, etc.)',
  ACCOMMODATION_LABEL: 'For guests travelling from outside the city, please select if you\'ll need accomodation:',
  FAVORITE_SONG_LABEL: "Will you be gracing us with a dance performance?",
  ADDITIONAL_INFO_LABEL: "Anything else you'd like us to know?",
  ADDITIONAL_INFO_PLACEHOLDER: "Travel plans, special needs, or just shower us with love ❤️",

  // Events - dynamically loaded from configuration
  getEnabledEvents: getEnabledEventsForRSVP,

  // Accommodation Options - dynamically loaded based on enabled events
  getAccommodationOptions: getEnabledAccommodationOptions,

  // Radio Options
  FAVORITE_SONG_OPTIONS: {
    YES: {
      value: 'yes',
      label: 'Yes, can\'t wait!',
    },
    NO: {
      value: 'no',
      label: 'No, I\'ll be cheering from the sidelines',
    },
  },

  // Form Validation Messages
  VALIDATION: {
    FULL_NAME_REQUIRED: 'Full name is required',
    EVENTS_REQUIRED: 'Please select at least one event to attend',
    PHONE_REQUIRED: 'Phone number is required',
    EMAIL_REQUIRED: 'Email address is required',
    EMAIL_INVALID: 'Please enter a valid email address',
  },

  // Button States
  BUTTON_SUBMIT: 'Submit RSVP',
  BUTTON_SUBMITTING: 'Submitting...',

  // Form Configuration
  TEXTAREA_ROWS: 3,
  GUESTS_MIN: 0,
} as const;